import moment from "moment";
import {
  API_ERROR,
  API_SUCCESS,
  API_SUCCESS_CHATHISTORY,
  API_SUCCESS_CREATE_INTERNAL_ATTACHMENTS,
  API_SUCCESS_CREATE_MACHINE,
  API_SUCCESS_CREATE_MANUFACTURER_ATTACHMENTS,
  API_SUCCESS_HEADER_SEARCH_REQUEST,
  API_SUCCESS_INTERNAL_ATTACHMENTS,
  API_SUCCESS_JOINEDCHATROOMS,
  API_SUCCESS_MACHINES,
  API_SUCCESS_MANUFACTURER_ATTACHMENTS,
  API_SUCCESS_USERS,
  INTER_SET_SAEDATA,
  SET_COPILOT_DIALOG,
  UPDATE_COPILOT,
  SET_DASHBOARD_LOADER,
  SET_NOTIFICATION_LOADER,
  COPILIT_ACTIVE_ID,
} from "../actions/api";

import { LOGOUT } from "../actions/auth";
import { RESET_URLS } from "../actions/notification";
import { UPDATE_ORDER_SUBSCRIPTION } from "../actions/ordersubscription";
import { PLAN_TITLE, USER_COST } from "../actions/plans";
import { SET_LOADER, SET_TAG_OPTIONS } from "../actions/ui";
import { RESET_ACTUAL_USERS, RESET_USERS } from "../actions/user";
import i18n from "./i18n";
import { sortUserData } from "../utils/helpers";
import { getItem, setItem } from "../utils/DataProtection";
// import { COPILOT_QUERRY } from "../actions/machines";

const getFreeUpto = (startingFrom, string) => {
  let letter = string[string.length - 1]; // reading last letter

  let time = 0;
  let targetStr = string.match(/-?\d+\.?\d*/)[0]; // getting numeric part from string "30d" ==> "30" , "3y" ===> "3"

  switch (letter) {
    case "D":
    case "d":
      time = moment(startingFrom).add("days", targetStr);
      break;

    case "Y":
    case "y":
      time = moment(startingFrom).add("Y", targetStr);
      break;

    case "M":
    case "m":
      time = moment(startingFrom).add("M", targetStr);
      break;

    default:
      time = 0;
  }

  time = moment(time).diff(new Date(), "days");

  return time;
};

const getPersistedAutoLogout = () => {
  const persistedValue = getItem("autoLogout");
  return persistedValue === false ? false : true;
};

export const reducer = (
  state = {
    snackbar: {
      open: false,
      title: "",
      description: "",
      severity: "success",
    },
    units: [], // to store counter units
    maintenanceTaskTemplates: [],
    uptimeClients: [],
    isSuperUserLogged: false,
    copilotLoading: "",
    copilotResponse: "",
    copilotDialog: false,
    activeCopilotNodeIds:
      (localStorage && JSON.parse(getItem("activeCopilotNodeIds"))) || [],
    activeCopilotNodeid: "",
    updateProfile: false,
    dashboardLoader: false,
    notificationsLoader: false,
    isAuthUser: true,
    user: JSON.parse(getItem("user")) || {},
    isLoading: false,
    error: null,
    loginError: null,
    data: (localStorage && JSON.parse(getItem("data"))) || {},
    openNotificationsData:
      (localStorage && JSON.parse(getItem("openNotificationsData"))) || {},
    filesUrlsNI: {},
    filesUrlsMI: {},
    chats: {},
    joinedrooms: {},
    chathistory: {},
    machines: {},
    users: {},
    enterprises: {},
    isadmin: getItem("isadmin") != undefined ? getItem("isadmin") : false,
    machineDetails: {},
    internalAttachments: {},
    manufacturerAttachments: {},
    machinepools: {},
    machinesofpool: {},
    saeData: (localStorage && JSON.parse(getItem("saeData"))) || {},
    language: "de", // TODO (@Rashid): Get user language
    i18n: i18n(),
    isSuperUser: localStorage && JSON.parse(getItem("isSuperUser")),
    appid: localStorage && getItem("appid"),
    userProfile: (localStorage && JSON.parse(getItem("userProfile"))) || {},
    bellNotifications:
      (localStorage && JSON.parse(getItem("bellNotifications"))) || {},
    notification: {},
    categories: {},
    aclusers: [],
    clientinfo: localStorage && JSON.parse(getItem("clientinfo")),
    searchData: {},
    streams: {},
    userExist: false,
    userType: "",
    autoLogout: getPersistedAutoLogout(),
    counters: [],
    counterTypes: [],
    costtypes: [],
    profiles: getItem("profiles") ? JSON.parse(getItem("profiles")) : "",
    profile: getItem("profile") ? JSON.parse(getItem("profile")) : "",
    profileid: localStorage && JSON.parse(getItem("profileid")),
    twoFa: localStorage && JSON.parse(getItem("twoFa")),
    QrCode: "",
    twoFaGenerated: localStorage && JSON.parse(getItem("twoFaGenerated")),
    twoFaApproved: localStorage && JSON.parse(getItem("twoFaApproved")),
    subscribedSites:
      (localStorage && JSON.parse(getItem("subscribedSites"))) || {},
    subscribedAreas:
      (localStorage && JSON.parse(getItem("subscribedAreas"))) || {},
    subscribedEquipmentpools:
      (localStorage && JSON.parse(getItem("subscribedEquipmentpools"))) || {},
    subscribedEquipments:
      (localStorage && JSON.parse(getItem("subscribedEquipments"))) || {},
    allsitesareaseqs:
      (localStorage && JSON.parse(getItem("allsitesareaseqs"))) || {},
    subscribedSitesNodeIds: new Set(),
    subscribedAreasNodeIds: new Set(),
    subscribedEquipmentPoolsNodeIds: new Set(),
    editUserSubscribedSites: {},
    editUserSubscribedAreas: {},
    editUserSubscribedEquipmentpools: {},
    editUserSubscribedEquipments: {},
    editUserSubscriptionsLoaded: false,
    emailSent: false, // share notification email flag
    legalEntities: [],
    plans: [],
    planTitle: "",
    userNumber: 1,
    notYetSubscribed: false,
    supportJson: {},
    isValidUser: getItem("isValidUser"),
    orderSubscription: {
      planTitle: "",
      userNumber: 1,
      firstName: "",
      lastName: "",
      companyName: "",
      address: "",
      country: "",
      city: "",
      zipCode: "",
      email: "",
      streetHouseNumber: "",
      telephoneNumber: "",
      department: "",
      invoiceEmail: "",
      orderNumber: 0,
    },
    kpis: {},
    aufgabeNotifications: [],
    tagOptions: [],
    tagsRaw: [],
    tagsRefreshKey: 0,
  },
  action
) => {
  switch (action.type) {
    case API_SUCCESS:
      const autoLogoutEnabled = action.payload["autologoutweb"] !== false;
      if (
        action.payload["isSuperUser"] !== undefined &&
        action.payload["isSuperUser"] !== false
      ) {
        // alert("Hallo , Welcome Super Admin!!")
        setItem("user", JSON.stringify(action.payload["accesstoken"]));
        setItem("autoLogout", autoLogoutEnabled);

        return {
          ...state,
          uptimeClients: action.payload["clients"],
          isSuperUserLogged: true,
          isAuthUser: true,
        };
      } else if (action.payload["accesstoken"] !== undefined) {
        const normalizedUserInfo = {
          ...action.payload["userinfo"],
          isReceiver:
            action.payload["userinfo"]?.isReceiver === undefined
              ? true
              : action.payload["userinfo"]?.isReceiver,
        };

        setItem("user", JSON.stringify(action.payload["accesstoken"]));
        setItem("autoLogout", autoLogoutEnabled);
        setItem(
          "legalentitynodeid",
          JSON.stringify(action.payload["legalentitynodeid"])
        );
        setItem("userinfo", JSON.stringify(normalizedUserInfo));
        setItem("usernodeid", JSON.stringify(action.payload["usernodeid"]));
        setItem("isSuperUser", JSON.stringify(action.payload["superuser"]));
        setItem("appid", JSON.stringify(action.payload["appid"]));
        setItem("isadmin", JSON.stringify(normalizedUserInfo.admin));
        setItem("refreshToken", JSON.stringify(action.payload["refreshtoken"]));
        setItem("clientid", JSON.stringify(action.payload["clientid"]));
        setItem("userid", JSON.stringify(action.payload["userid"]));
        setItem("clientinfo", JSON.stringify(action.payload["clientinfo"]));
        setItem("tabsOpen", 1);
        setItem(
          "profileid",
          JSON.stringify(
            normalizedUserInfo.profileid !== undefined
              ? normalizedUserInfo.profileid
              : ""
          )
        );
        setItem(
          "profiles",
          JSON.stringify(
            action.payload["profiles"] !== undefined
              ? action.payload["profiles"]
              : ""
          )
        );
        setItem(
          "profile",
          JSON.stringify(
            action.payload["profiles"]
              ? action.payload["profiles"].filter(
                  (p) => p.id === normalizedUserInfo.profileid
                )[0]
              : ""
          )
        );
        setItem(
          "twoFaGenerated",
          JSON.stringify(action.payload["twoFaGenerated"])
        );
        setItem(
          "twoFa",
          JSON.stringify(
            action.payload["twoFa"] !== undefined ? action.payload["twoFa"] : ""
          )
        );
        setItem("twoFaApproved", JSON.stringify({ result: false }));

        if (action.payload["plans"].length) {
          let freePlan = action.payload["plans"].filter(
            (plan) => plan.name === "free"
          );

          if (freePlan?.length) {
            let freeUpto = getFreeUpto(
              freePlan[0].quotas[0].startingfrom,
              freePlan[0].quotas[0].quota
            );

            let daysLeft = freeUpto;
            if (daysLeft >= 0) {
              setItem("daysLeft", daysLeft);
              setItem("notyetSubscribed", true);
            } else {
              setItem("daysLeft", -1);
            }

            setItem("isValidUser", freePlan[0].quotas[0].status.isvalid);

            if (freePlan[0].quotas[0].status.isvalid === false) {
              setItem("rdtOrderSubs", true);
              // window.location.href = "/orderSubscription";
            }
          } else {
            let timePlan = action.payload["plans"][0]["quotas"];

            if (timePlan.length) {
              let freeUpto = getFreeUpto(
                timePlan[0].startingfrom,
                timePlan[0].quota
              );

              let daysLeft = freeUpto;
              if (daysLeft >= 0) {
                setItem("daysLeft", daysLeft);
                setItem("notyetSubscribed", true);
              }

              setItem("isValidUser", timePlan[0].status.isvalid);

              if (timePlan[0].status.isvalid === false) {
                setItem("rdtOrderSubs", true);
                // window.location.href = "/orderSubscription";
              }
            } else {
              setItem("daysLeft", -1);
            }
          }
        }

        setItem(
          "notYetSubscribed",
          action.payload["userType"] === "free" ? true : false
        );
        setItem(
          "plans",
          action.payload["plans"] ? JSON.stringify(action.payload["plans"]) : []
        );

        setItem(
          "baseinfo",
          action.payload["baseinfo"]
            ? JSON.stringify(action.payload["baseinfo"])
            : []
        );

        setItem(
          "billinginfo",
          action.payload["billinginfo"]
            ? JSON.stringify(action.payload["billinginfo"])
            : []
        );

        return {
          ...state,
          twoFa: action.payload["twoFa"],
          twoFaApproved: { result: false },
          isLoading: false,
          isAuthUser: true,
          user: { ...action.payload, userinfo: normalizedUserInfo },
          isadmin: normalizedUserInfo.admin,
          isSuperUser: action.payload["superuser"],
          appid: action.payload["appid"],
          userType: action.payload["userType"],
          autoLogout: autoLogoutEnabled,
          profiles: action.payload["profiles"],
          profile:
            action.payload["profiles"] &&
            action.payload["profiles"].filter(
              (p) => p.id === normalizedUserInfo.profileid
            )[0],
          profileid: normalizedUserInfo && normalizedUserInfo.profileid,
          twoFaGenerated: action.payload["twoFaGenerated"],
          dashboardLoader: false,
          isValidUser: getItem("isValidUser"),
        };
      } else if (action.payload["statusCode"] == 401) {
        return { ...state, loginError: "Ungültige Anmeldeinformationen" };
      } else if (action.payload["statusCode"] == 403) {
        return { ...state, loginError: "Access Denied" };
      } else if (action.optype == "GET_LEGALENTITY") {
        /* console.log(action.payload, "????"); */
        return { ...state, legalEntities: action.payload };
      } else if (action.optype == "NI") {
        return { ...state, filesUrlsNI: action.payload };
      } else if (action.optype == "MI") {
        return { ...state, filesUrlsMI: action.payload };
      } else if (action.optype == "MOPOOL") {
        return { ...state, machinesofpool: action.payload };
      } else if (action.optype == "MPOUSER") {
        return { ...state, machinepools: action.payload };
      } else if (action.optype == "SAE") {
        setItem("saeData", JSON.stringify(action.payload));
        return { ...state, saeData: action.payload };
      } else if (action.optype === "SUPPORT_JSON") {
        return { ...state, supportJson: action.payload };
      } else if (action.optype == "USER") {
        setItem("userProfile", JSON.stringify(action.payload));
        return { ...state, userProfile: action.payload };
      } else if (action.optype == "UPDATENOTIFICATIONSTATUS") {
        return { ...state };
      } else if (action.optype == "UPDATENOTIFICATIONALL") {
        return { ...state };
      } else if (
        action.optype == "ALLNOTIFICATIONS" ||
        action.optype == "OPEN_NOTIFICATIONS"
      ) {
        let notifications = [];
        let keys = [];

        action.payload.data &&
          action.payload.data.map((data) => {
            data.equipment?.hasnotification &&
              data.equipment.hasnotification.map((noti) => {
                noti.notification.equipmentnodeid = data.equipment.nodeid;
                notifications.push(noti);
              });
          });

        setItem("bellNotifications", JSON.stringify(action.payload["keys"]));
        if (action.optype == "ALLNOTIFICATIONS") {
          setItem("data", JSON.stringify(notifications));
        } else if (action.optype == "OPEN_NOTIFICATIONS") {
          setItem("openNotificationsData", JSON.stringify(notifications));
        }
        return {
          ...state,
          data:
            action.optype == "ALLNOTIFICATIONS" ? notifications : state.data,
          openNotificationsData:
            action.optype == "OPEN_NOTIFICATIONS"
              ? notifications
              : state.openNotificationsData,
          bellNotifications: action.payload["keys"],
          notificationsLoader: false,
        };
      } else if (action.optype === "AUFGABE_NOTIS") {
        return {
          ...state,
          aufgabeNotifications: action.payload["result"],
        };
      } else if (action.optype == "MARKREADNOTIFICATION") {
        return { ...state };
      } else if (action.optype == "GETSINGLENOTIFICATION") {
        return { ...state, notification: action.payload };
      } else if (action.optype == "GETALLCATEGORIES") {
        return { ...state, categories: action.payload };
      } else if (action.optype == "mtTemplates") {
        return {
          ...state,
          maintenanceTaskTemplates: action.payload[0]
            ? action.payload[0].legalentity.hasmaintenancetasktemplate
            : [],
        };
      } else if (action.optype === "DELETE_MT_TEMPLATE") {
        return { ...state, maintenanceTaskTemplates: [] };
      } else if (action.optype == "ACL_USERS") {
        return { ...state, aclusers: action.payload };
      } else if (action.optype == "SEARCH_USER_CHAT") {
        return { ...state, users: action.payload };
      } else if (action.optype == "UPDATEWORKFLOW") {
        return { ...state };
      } else if (action.optype == "UPDATEREPORT") {
        return { ...state };
      } else if (action.optype == "EquipmentStream") {
        return { ...state, streams: action.payload };
      } else if (action.optype == "CHECK_USER") {
        return { ...state, userExist: action.payload };
      } else if (action.optype == "COUNTERS") {
        return { ...state, counters: action.payload["result"][0]["data"] };
      } else if (action.optype == "COUNTER_TYPES") {
        return { ...state, counterTypes: action.payload["result"][0]["data"] };
      } else if (action.optype == "COST_TYPES") {
        return { ...state, costtypes: action.payload["result"][0]["data"] };
      } else if (action.optype == "GET_TAGS") {
        const tagRows =
          action?.payload?.result?.[0]?.data ||
          action?.payload?.data ||
          action?.payload?.tags ||
          [];
        const rows = Array.isArray(tagRows) ? tagRows : [];
        const labels = rows
          .map((row) => {
            if (typeof row === "string") return row.trim();
            if (typeof row?.tag?.label === "string") return row.tag.label.trim();
            if (typeof row?.label === "string") return row.label.trim();
            return "";
          })
          .filter(Boolean);
        return {
          ...state,
          tagsRaw: rows,
          tagOptions: [...new Set([...(state.tagOptions || []), ...labels])],
        };
      } else if (action.optype == "CREATE_TAG") {
        const createdLabel =
          action?.payload?.result?.[0]?.data?.[0]?.tag?.label ||
          action?.payload?.tag?.label ||
          action?.payload?.label ||
          "";
        const nextRefreshKey = (state.tagsRefreshKey || 0) + 1;
        if (!createdLabel) return { ...state, tagsRefreshKey: nextRefreshKey };
        return {
          ...state,
          tagOptions: [...new Set([...(state.tagOptions || []), createdLabel])],
          tagsRefreshKey: nextRefreshKey,
        };
      } else if (action.optype == "DELETE_TAG") {
        return {
          ...state,
          tagsRefreshKey: (state.tagsRefreshKey || 0) + 1,
        };
      } else if (action.optype == "Authenticate2Fa") {
        setItem("twoFaApproved", JSON.stringify(action.payload));
        return { ...state, twoFaApproved: action.payload };
      } else if (action.optype == "SAE2") {
        let subscribedEquipmentpools = {};

        let subscribedSites = {};

        let subscribedAreas = {};

        let subscribedEquipments = {};
        const newSubscribedEquipmentPoolsNodeIds = new Set();
        const newSubscribedSitesNodeIds = new Set();
        const newSubscribedAreasNodeIds = new Set();
        const sorted = sortUserData(action.payload[0]?.data);
        if (sorted[0]?.user?.issubscriberof?.length > 0) {
          for (const subscribedItem of sorted[0]?.user?.issubscriberof) {
            //check subscribed equipmentpool

            if (subscribedItem?.equipmentpool != undefined) {
              subscribedEquipmentpools[subscribedItem.equipmentpool.nodeid] =
                subscribedItem.equipmentpool;

              newSubscribedEquipmentPoolsNodeIds.add(
                subscribedItem.equipmentpool.nodeid
              );

              if (subscribedItem?.equipmentpool) {
                if (subscribedItem?.equipmentpool?.hasequipment) {
                  for (const equipmentItem of subscribedItem.equipmentpool
                    .hasequipment) {
                    subscribedEquipments[equipmentItem.equipment.nodeid] =
                      equipmentItem.equipment;
                  }
                }
              }
            }
            //check subscribed site

            if (subscribedItem?.site != undefined) {
              subscribedSites[subscribedItem.site.nodeid] = subscribedItem.site;
              /* console.log(subscribedItem.site,"subscribedItem.site") */
              newSubscribedSitesNodeIds.add(subscribedItem.site.nodeid);

              if (subscribedItem.site?.hasarea) {
                for (const areaItem of subscribedItem.site?.hasarea) {
                  subscribedAreas[areaItem.area.nodeid] = areaItem.area;
                  if (areaItem.area.hasequipment) {
                    for (const equipmentItem of areaItem.area.hasequipment) {
                      subscribedEquipments[equipmentItem.equipment.nodeid] =
                        equipmentItem.equipment;
                    }
                  }
                }
              }
            }
            //check subscribed areas

            if (subscribedItem.area != undefined) {
              const siteItem = subscribedItem.area.isareaof[0];

              if (subscribedSites[siteItem.site.nodeid] === undefined) {
                //the site of the area is not subscribed

                siteItem.site.hasarea = [];

                subscribedSites[siteItem.site.nodeid] = siteItem.site;
              }

              if (
                subscribedSites[siteItem.site.nodeid]?.hasarea &&
                subscribedSites[siteItem.site.nodeid]?.hasarea.findIndex(
                  (item) => item.area.nodeid === subscribedItem.area.nodeid
                ) === -1
              ) {
                //the area is not in the site

                subscribedSites[siteItem.site.nodeid].hasarea.push(
                  _.omit(subscribedItem, "hasarea")
                );
              }

              subscribedAreas[subscribedItem.area.nodeid] = _.omit(
                subscribedItem.area,
                "hasarea"
              );

              newSubscribedAreasNodeIds.add(subscribedItem.area.nodeid);
              if (subscribedItem.area.hasequipment) {
                for (const equipmentItem of subscribedItem.area.hasequipment) {
                  subscribedEquipments[equipmentItem.equipment.nodeid] =
                    equipmentItem.equipment;
                }
              }
            }
          }
        }

        try {
          setItem("subscribedAreas", JSON.stringify(subscribedAreas));

          setItem("subscribedEquipments", JSON.stringify(subscribedEquipments));

          setItem(
            "subscribedEquipmentpools",
            JSON.stringify(subscribedEquipmentpools)
          );

          setItem("subscribedSites", JSON.stringify(subscribedSites));
        } catch (err) {
          console.log(err);
        }

        return {
          ...state,
          subscribedSites: subscribedSites,
          subscribedAreas: subscribedAreas,
          subscribedEquipmentpools: subscribedEquipmentpools,
          subscribedEquipments: subscribedEquipments,
          subscribedSitesNodeIds: newSubscribedSitesNodeIds,
          subscribedAreasNodeIds: newSubscribedAreasNodeIds,
          subscribedEquipmentPoolsNodeIds: newSubscribedEquipmentPoolsNodeIds,
          dashboardLoader: false,
          notificationsLoader: false,
        };
      } else if (action.optype == "SAE2_ADMIN_USER") {
        let subscribedEquipmentpools = {};
        let subscribedSites = {};
        let subscribedAreas = {};
        let subscribedEquipments = {};

        const sorted = sortUserData(action.payload[0]?.data);
        if (sorted[0]?.user?.issubscriberof?.length > 0) {
          for (const subscribedItem of sorted[0]?.user?.issubscriberof) {
            if (subscribedItem?.equipmentpool != undefined) {
              subscribedEquipmentpools[subscribedItem.equipmentpool.nodeid] =
                subscribedItem.equipmentpool;
              if (subscribedItem?.equipmentpool?.hasequipment) {
                for (const equipmentItem of subscribedItem.equipmentpool
                  .hasequipment) {
                  subscribedEquipments[equipmentItem.equipment.nodeid] =
                    equipmentItem.equipment;
                }
              }
            }

            if (subscribedItem?.site != undefined) {
              subscribedSites[subscribedItem.site.nodeid] = subscribedItem.site;
              if (subscribedItem.site?.hasarea) {
                for (const areaItem of subscribedItem.site?.hasarea) {
                  subscribedAreas[areaItem.area.nodeid] = areaItem.area;
                  if (areaItem.area.hasequipment) {
                    for (const equipmentItem of areaItem.area.hasequipment) {
                      subscribedEquipments[equipmentItem.equipment.nodeid] =
                        equipmentItem.equipment;
                    }
                  }
                }
              }
            }

            if (subscribedItem.area != undefined) {
              const siteItem = subscribedItem.area.isareaof?.[0];
              if (siteItem?.site?.nodeid) {
                if (subscribedSites[siteItem.site.nodeid] === undefined) {
                  siteItem.site.hasarea = [];
                  subscribedSites[siteItem.site.nodeid] = siteItem.site;
                }

                if (
                  subscribedSites[siteItem.site.nodeid]?.hasarea &&
                  subscribedSites[siteItem.site.nodeid]?.hasarea.findIndex(
                    (item) => item.area.nodeid === subscribedItem.area.nodeid
                  ) === -1
                ) {
                  subscribedSites[siteItem.site.nodeid].hasarea.push(
                    subscribedItem
                  );
                }
              }

              subscribedAreas[subscribedItem.area.nodeid] = subscribedItem.area;
              if (subscribedItem.area.hasequipment) {
                for (const equipmentItem of subscribedItem.area.hasequipment) {
                  subscribedEquipments[equipmentItem.equipment.nodeid] =
                    equipmentItem.equipment;
                }
              }
            }
          }
        }

        console.log(subscribedSites,"subscribedSites")

        return {
          ...state,
          editUserSubscribedSites: subscribedSites,
          editUserSubscribedAreas: subscribedAreas,
          editUserSubscribedEquipmentpools: subscribedEquipmentpools,
          editUserSubscribedEquipments: subscribedEquipments,
          editUserSubscriptionsLoaded: true,
        };
      } else if (action.optype == "ALL_SAE") {
        try {
          setItem("allsitesareaseqs", JSON.stringify(action.payload));
        } catch (err) {
          console.log(err);
        }
        return { ...state, allsitesareaseqs: action.payload };
      } else if (action.optype == "ALL_SAE_EMPTY") {
        return { ...state, allsitesareaseqs: action.payload };
      } else if (action.optype == "assignSAE") {
        return { ...state, updateProfile: true };
      } else if (action.optype == "GETKPISDATA") {
        return { ...state, kpis: action.payload };
      } else if (action.optype == "UNITS") {
        return { ...state, units: action.payload };
      } else {
        return { ...state, loginError: null, chats: {} };
      }

    case SET_COPILOT_DIALOG:
      return { ...state, copilotDialog: action.payload };

    case COPILIT_ACTIVE_ID:
      return { ...state, activeCopilotNodeid: action.payload };

    // case COPILOT_QUERRY:
    //   return {...state, copilotResponse: action.payload}
    case UPDATE_COPILOT:
      setItem("activeCopilotNodeIds", JSON.stringify(action.payload));
      return { ...state, activeCopilotNodeIds: action.payload };

    case "SHOW_SNACKBAR":
      return {
        ...state,
        snackbar: {
          open: true,
          title: action.payload.title,
          description: action.payload.description,
          severity: action.payload.severity || "success",
        },
      };
    case "HIDE_SNACKBAR":
      return {
        ...state,
        snackbar: {
          ...state.snackbar,
          open: false,
          title: "",
          description: "",
          severity: "",
        },
      };

    case SET_DASHBOARD_LOADER:
      return { ...state, dashboardLoader: action.payload };
    case SET_NOTIFICATION_LOADER:
      return { ...state, notificationsLoader: action.payload };
    case SET_TAG_OPTIONS:
      return { ...state, tagOptions: action.payload || [] };
    case "RESET_EDIT_USER_SUBSCRIPTIONS":
      return {
        ...state,
        editUserSubscribedSites: {},
        editUserSubscribedAreas: {},
        editUserSubscribedEquipmentpools: {},
        editUserSubscribedEquipments: {},
        editUserSubscriptionsLoaded: false,
      };
    case API_SUCCESS_HEADER_SEARCH_REQUEST:
      return { ...state, isLoading: false, searchData: action.payload };
    case INTER_SET_SAEDATA:
      if (action.payload.data != undefined) {
        return { ...state, saeData: action.payload };
      }
    case UPDATE_ORDER_SUBSCRIPTION:
      return {
        ...state,
        orderSubscription: {
          ...state.orderSubscription,
          ...action.payload,
        },
      };

    case "CLEARNOTIFICATION":
      if (state.notification !== undefined)
        return { ...state, notification: {} };
    case "CLEARMACHINE":
      if (state.machines !== undefined) return { ...state, machines: {} };
    case "EMAIL_SENT":
      return { ...state, emailSent: action.payload };
    case API_SUCCESS_CHATHISTORY:
      return { ...state, chathistory: action.payload };
    case API_SUCCESS_JOINEDCHATROOMS:
      return { ...state, joinedrooms: action.payload };
    case API_SUCCESS_MACHINES:
      return { ...state, machines: action.payload };
    case API_SUCCESS_CREATE_MACHINE:
      return { ...state, enterprises: action.payload };
    case API_SUCCESS_USERS:
      return { ...state, users: action.payload[0]["legalentity"]["hasmember"] };
    case API_SUCCESS_INTERNAL_ATTACHMENTS:
      return { ...state, internalAttachments: action.payload };
    case API_SUCCESS_MANUFACTURER_ATTACHMENTS:
      return { ...state, manufacturerAttachments: action.payload };
    case API_SUCCESS_CREATE_MANUFACTURER_ATTACHMENTS:
    //console.log('manufacturer attachment Created..')
    case API_SUCCESS_CREATE_INTERNAL_ATTACHMENTS:
    //console.log('internal attachment Created..')
    case API_ERROR:
      return { ...state, error: action.payload };
    case SET_LOADER:
      return { ...state, isLoading: action.payload };
    case RESET_URLS:
      return { ...state, filesUrls: {} };
    case RESET_USERS:
      return { ...state, users: {} };
    case RESET_ACTUAL_USERS:
      return { ...state, aclusers: {} };
    case LOGOUT:
      localStorage.clear();
      return {
        ...state,
        loginError: null,
        isAuthUser: false,
        isadmin: false,
        user: {},
        saeData: {},
        data: {},
        bellNotifications: {},
        notification: {},
        users: {},
        aclusers: {},
        clientinfo: "",
        twoFa: undefined,
        twoFaGenerated: false,
        twoFaApproved: undefined,
        subscribedSites: {},
        subscribedAreas: {},
        subscribedEquipmentpools: {},
        subscribedEquipments: {},
        subscribedSitesNodeIds: new Set(),
        subscribedAreasNodeIds: new Set(),
        subscribedEquipmentPoolsNodeIds: new Set(),
        editUserSubscribedSites: {},
        editUserSubscribedAreas: {},
        editUserSubscribedEquipmentpools: {},
        editUserSubscribedEquipments: {},
        activeCopilotNodeIds: [],
        uptimeClients: [],
        isSuperUserLogged: false,
      };
    default:
      return state;
  }
};
export default reducer;

export const Check = () => (setState) => {
  setState({ isDone: true });
};
